'use es6';

import { createSelector } from 'reselect';
import { getIsUserJitad } from 'ContentEditorUI/redux/selectors/authSelectors';
import { getIsReadOnlyModeForCritsit } from 'ContentEditorUI/redux/selectors/appStatusSelectors';
import { makeGetHasTestFlag } from 'ContentEditorUI/redux/selectors/testFlagSelectors';
import { getHasAccessToAutomationTabOnly } from 'EmailEditorUI/redux/selectors/EmailSelectors';
import { getHasEmailWriteScope, getIsReadOnlyModeToCustomEditor } from 'EmailEditorUI/redux/selectors/AuthSelectors';

// allow specific testing of read only email selector
export const READ_ONLY = 'readOnlyEmail';
const getTestReadOnly = makeGetHasTestFlag(READ_ONLY);
export const getBaseReadOnlySelector = createSelector([getIsReadOnlyModeForCritsit, getTestReadOnly, getHasEmailWriteScope, getIsUserJitad, getIsReadOnlyModeToCustomEditor], (readOnlyForCritsit, testReadOnly, hasWriteScope, isUserJitad, readonlyCustomEditorAccess) => {
  return !isUserJitad && !hasWriteScope || readonlyCustomEditorAccess || readOnlyForCritsit || testReadOnly;
});
export const getIsReadOnlyMode = createSelector([getBaseReadOnlySelector, getHasAccessToAutomationTabOnly], (isReadOnly, hasAccessToAutomationTabOnly) => {
  return isReadOnly || hasAccessToAutomationTabOnly;
});